define("shared/components/shared/post/secondary/hashtag-suggestions/error", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--blank">
    <h2 class="o--blank__title qa--hashtagSuggestions_msgTitle">
      {{#if @isSearch}}
        {{t "hashtag_suggestions.error_search" hashtag=@hashtagQuery}}
      {{else}}
        {{t "hashtag_suggestions.error_auto"}}
      {{/if}}
    </h2>
    <p class="o--blank__desc qa--hashtagSuggestions_msgDescription">
      {{#if @isSearch}}
        {{t "hashtag_suggestions.error_search_subtitle"}}
      {{else}}
        {{t "hashtag_suggestions.error_auto_subtitle"}}
      {{/if}}
    </p>
  </div>
  */
  {
    "id": "Rm8imUCJ",
    "block": "[[[10,0],[14,0,\"o--blank\"],[12],[1,\"\\n  \"],[10,\"h2\"],[14,0,\"o--blank__title qa--hashtagSuggestions_msgTitle\"],[12],[1,\"\\n\"],[41,[30,1],[[[1,\"      \"],[1,[28,[35,1],[\"hashtag_suggestions.error_search\"],[[\"hashtag\"],[[30,2]]]]],[1,\"\\n\"]],[]],[[[1,\"      \"],[1,[28,[35,1],[\"hashtag_suggestions.error_auto\"],null]],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n  \"],[10,2],[14,0,\"o--blank__desc qa--hashtagSuggestions_msgDescription\"],[12],[1,\"\\n\"],[41,[30,1],[[[1,\"      \"],[1,[28,[35,1],[\"hashtag_suggestions.error_search_subtitle\"],null]],[1,\"\\n\"]],[]],[[[1,\"      \"],[1,[28,[35,1],[\"hashtag_suggestions.error_auto_subtitle\"],null]],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@isSearch\",\"@hashtagQuery\"],false,[\"if\",\"t\"]]",
    "moduleName": "shared/components/shared/post/secondary/hashtag-suggestions/error.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});